module.exports = __webpack_public_path__ + "images/category_lp/common/man_20_651bc5726aa4430ddd262b64b8408cac.png";